__turbopack_context__.v({
  "className": "berkeleymonovariable_a01603e5-module__Cf5aWq__className",
});
